import { erroPeriodoConsulta } from '../../../core/tools/periodo-consulta';
import { Component, OnInit } from '@angular/core';
import { Animacao } from '../../../core/tools/animacao';
import {
  WhatsAppOfficialDashboard,
  WhatsAppOfficialDashboardAtendimento,
  WhatsAppOfficialDashboardDirecao,
  WhatsAppOfficialDashboardFiltro,
  WhatsAppOfficialDashboardFunil,
  WhatsAppOfficialDashboardInstancia,
  WhatsAppOfficialDashboardMapaHora,
  WhatsAppOfficialDashboardVendedor
} from '../../../core/models/whatsapp-oficial/whatsapp-oficial-dashboard';
import { WhatsAppOfficialService } from '../../../core/services/whatsapp-oficial/whatsapp-oficial.service';

@Component({
  selector: 'app-dashboard-venda-interna-whatsapp',
  templateUrl: './dashboard-venda-interna-whatsapp.component.html',
  styleUrls: ['./dashboard-venda-interna-whatsapp.component.css'],
  preserveWhitespaces: false,
  animations: [Animacao],
  standalone: false
})
export class DashboardVendaInternaWhatsappComponent implements OnInit {
  erroPeriodo = '';
  dataHoje: string = '';
  carregando: boolean = false;
  filtro: WhatsAppOfficialDashboardFiltro = new WhatsAppOfficialDashboardFiltro();
  dashboard: WhatsAppOfficialDashboard = new WhatsAppOfficialDashboard();
  horasMapa: number[] = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
  filtroInstancias: 'CONECTADAS' | 'DESCONECTADAS' = null;

  constructor(private whatsAppOfficialService: WhatsAppOfficialService) { }

  ngOnInit() {
    const hoje = new Date();
    this.dataHoje = new Date(hoje.getTime() - hoje.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    this.filtro.data_inicio = this.dataHoje;
    this.filtro.data_fim = this.dataHoje;
    this.atualizar();
  }

  atualizar() {
    this.erroPeriodo = erroPeriodoConsulta(this.filtro.data_inicio, this.filtro.data_fim);
    if (this.erroPeriodo) return;
    this.carregando = true;
    this.whatsAppOfficialService.getDashboard(this.filtro).subscribe(
      dashboard => {
        this.dashboard = Object.assign(new WhatsAppOfficialDashboard(), dashboard || new WhatsAppOfficialDashboard());
        this.filtroInstancias = null;
      },
      () => this.carregando = false,
      () => this.carregando = false
    );
  }

  exportarAtendimentos() {
    window.print();
  }

  get totalFunil(): number {
    return Math.max(...(this.dashboard.funil || []).map(item => item.quantidade || 0), 1);
  }

  larguraFunil(item: WhatsAppOfficialDashboardFunil): number {
    return Math.max(4, Math.round(((item.quantidade || 0) / this.totalFunil) * 100));
  }

  classeEtapa(tipo: string): string {
    const normalizado = (tipo || '').toUpperCase();

    if (normalizado == 'GANHO') {
      return 'viw-pill-green';
    }

    if (normalizado == 'PERDA') {
      return 'viw-pill-red';
    }

    if (normalizado == 'ATENDIMENTO') {
      return 'viw-pill-amber';
    }

    return 'viw-pill-blue';
  }

  classeBarraEtapa(tipo: string): string {
    const normalizado = (tipo || '').toUpperCase();

    if (normalizado == 'GANHO') {
      return 'viw-green';
    }

    if (normalizado == 'PERDA') {
      return 'viw-red';
    }

    if (normalizado == 'ATENDIMENTO') {
      return 'viw-amber';
    }

    return '';
  }

  rotuloDirecao(direcao: string): string {
    const normalizada = (direcao || '').toUpperCase();

    if (normalizada == 'INBOUND') {
      return 'Recebida';
    }

    if (normalizada == 'OUTBOUND') {
      return 'Feita';
    }

    return 'Nao informada';
  }

  totalDirecao(direcao: WhatsAppOfficialDashboardDirecao): number {
    return (direcao.aberto || 0) + (direcao.atendimento || 0) + (direcao.ganho || 0) + (direcao.perda || 0);
  }

  percentual(valor: number, total: number): number {
    if (!total || total <= 0) {
      return 0;
    }

    return Math.round(((valor || 0) / total) * 100);
  }

  get datasMapa(): WhatsAppOfficialDashboardMapaHora[] {
    const datas = new Map<string, WhatsAppOfficialDashboardMapaHora>();

    (this.dashboard.mapa_horas || []).forEach(item => {
      const chave = item.data_atendimento || item.data_atendimento_label || item.dia_semana_nome;

      if (!datas.has(chave)) {
        datas.set(chave, item);
      }
    });

    return Array.from(datas.values());
  }

  rotuloDataMapa(item: WhatsAppOfficialDashboardMapaHora): string {
    if (item == null) {
      return '-';
    }

    return `${item.data_atendimento_label || item.data_atendimento} ${item.dia_semana_nome || ''}`.trim();
  }

  valorMapa(data: string, hora: number): number {
    const item = (this.dashboard.mapa_horas || []).find(x => (x.data_atendimento || x.data_atendimento_label) == data && x.hora == hora);
    return item == null ? 0 : item.quantidade || 0;
  }

  classeMapa(data: string, hora: number): string {
    const valor = this.valorMapa(data, hora);
    const maximo = Math.max(...(this.dashboard.mapa_horas || []).map(item => item.quantidade || 0), 1);
    const pct = valor / maximo;

    if (pct >= 0.75) {
      return 'h4';
    }

    if (pct >= 0.5) {
      return 'h3';
    }

    if (pct >= 0.25) {
      return 'h2';
    }

    return 'h1';
  }

  minutos(valor: number): string {
    if (valor == null || isNaN(valor)) {
      return '-';
    }

    if (valor < 60) {
      return `${Math.max(0, valor)}m`;
    }

    const horas = Math.floor(valor / 60);
    const minutos = valor % 60;
    return `${horas.toString().padStart(2, '0')}h ${minutos.toString().padStart(2, '0')}m`;
  }

  hora(valor: string): string {
    if (!valor) {
      return '-';
    }

    const data = new Date(valor);
    return isNaN(data.getTime()) ? '-' : data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  }

  dataHora(valor: string): string {
    if (!valor) {
      return '-';
    }

    const data = new Date(valor);

    if (isNaN(data.getTime())) {
      return '-';
    }

    return data.toLocaleDateString('pt-BR') + ' ' + data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  }

  nomeVendedor(vendedor: WhatsAppOfficialDashboardVendedor): string {
    return vendedor.vendedor || 'Sem responsavel';
  }

  statusInstancia(instancia: WhatsAppOfficialDashboardInstancia): string {
    return instancia.status || (instancia.conectada ? 'Conectada' : 'Desconectada');
  }

  abrirInstancias(tipo: 'CONECTADAS' | 'DESCONECTADAS') {
    this.filtroInstancias = this.filtroInstancias == tipo ? null : tipo;
  }

  get instanciasFiltradas(): WhatsAppOfficialDashboardInstancia[] {
    if (this.filtroInstancias == null || this.dashboard.saude_instancias == null) {
      return [];
    }

    const conectada = this.filtroInstancias == 'CONECTADAS';
    return (this.dashboard.saude_instancias.instancias || []).filter(instancia => instancia.conectada == conectada);
  }

  get tituloInstanciasFiltradas(): string {
    if (this.filtroInstancias == 'CONECTADAS') {
      return 'Vendedores com instância conectada';
    }

    if (this.filtroInstancias == 'DESCONECTADAS') {
      return 'Vendedores com instância desconectada';
    }

    return '';
  }

  trackById(_: number, item: WhatsAppOfficialDashboardAtendimento): number {
    return item.id;
  }
}
